import { Component } from '@angular/core';

@Component({
  selector: 'i-cross',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
      <path
        d="M27.1732 0.453604C26.883 0.163477 26.4887 0.000247738 26.0785 1.3911e-08C25.7705 1.3911e-08 25.4722 0.0917403 25.2197 0.260069L24.9838 0.453604L16.6998 8.72641C16.3091 9.11658 15.6761 9.11626 15.2858 8.72569L7.01937 0.453604C6.72908 0.163209 6.33528 0.000103232 5.9247 1.3911e-08C5.61682 -4.12735e-05 5.31835 0.0918229 5.06588 0.260069L4.83 0.453604L0.453312 4.83029C-0.151032 5.43484 -0.151011 6.41503 0.453312 7.01966L8.71976 15.2898C9.1101 15.6803 9.11006 16.3133 8.71968 16.7037L0.453312 24.9721C-0.151218 25.5765 -0.150991 26.5567 0.453312 27.1613L4.83 31.538C5.12036 31.8284 5.51407 31.9917 5.9247 31.9917C6.33517 31.9915 6.7291 31.8284 7.01937 31.538L15.2853 23.2702C15.6758 22.8796 16.309 22.8796 16.6996 23.2701L24.9656 31.5361C25.5701 32.1404 26.5502 32.142 27.1551 31.538L31.5338 27.1634C31.8241 26.8731 31.9871 26.4792 31.9874 26.0686C31.9874 25.658 31.8241 25.2644 31.5338 24.9741L23.2661 16.7064C22.8754 16.3157 22.8756 15.6822 23.2666 15.2918L31.5458 7.02368C32.1506 6.41965 32.1515 5.43939 31.5478 4.83434L27.1732 0.453604Z"
        fill="currentColor"
      />
    </svg>
  `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconCross {}
